import {
  PSMS_PA_CASE_SUBMISSION_REQUEST,
  PSMS_PA_CASE_SUBMISSION_SUCCESS,
  PSMS_PA_CASE_SUBMISSION_FAILURE,
  PSMS_PA_CASE_SUBMISSION_LOADING,
  PSMS_PA_CASE_SUBMISSION_CHANNEL_REQUEST,
  PSMS_PA_CASE_SUBMISSION_CHANNEL_SUCCESS,
  PSMS_PA_CASE_SUBMISSION_CHANNEL_FAILURE,
  PSMS_PA_CASE_SUBMISSION_CHANNEL_LOADING,
  PSMS_PA_APPROVAL_DENIAL_TREND_REQUEST,
  PSMS_PA_APPROVAL_DENIAL_TREND_SUCCESS,
  PSMS_PA_APPROVAL_DENIAL_TREND_FAILURE,
  PSMS_PA_APPROVAL_DENIAL_TREND_LOADING,
  PSMS_PA_TAT_TREND_REQUEST,
  PSMS_PA_TAT_TREND_SUCCESS,
  PSMS_PA_TAT_TREND_FAILURE,
  PSMS_PA_TAT_TREND_LOADING,
} from '../actionTypes';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPSMSPACaseSubmissionRequest = (payload: any) => ({
  type: PSMS_PA_CASE_SUBMISSION_REQUEST,
  payload,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPSMSPACaseSubmissionSuccess = (payload: any) => ({
  type: PSMS_PA_CASE_SUBMISSION_SUCCESS,
  payload,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPSMSPACaseSubmissionFailure = (payload: any) => ({
  type: PSMS_PA_CASE_SUBMISSION_FAILURE,
  payload,
});

export const getPSMSPACaseSubmissionLoading = (payload: boolean) => ({
  type: PSMS_PA_CASE_SUBMISSION_LOADING,
  payload,
});

// Case Submission Channel Actions
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPSMSPACaseSubmissionChannelRequest = (payload: any) => ({
  type: PSMS_PA_CASE_SUBMISSION_CHANNEL_REQUEST,
  payload,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPSMSPACaseSubmissionChannelSuccess = (payload: any) => ({
  type: PSMS_PA_CASE_SUBMISSION_CHANNEL_SUCCESS,
  payload,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPSMSPACaseSubmissionChannelFailure = (payload: any) => ({
  type: PSMS_PA_CASE_SUBMISSION_CHANNEL_FAILURE,
  payload,
});

export const getPSMSPACaseSubmissionChannelLoading = (payload: boolean) => ({
  type: PSMS_PA_CASE_SUBMISSION_CHANNEL_LOADING,
  payload,
});

// Approval Denial Trend Actions
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPSMSPAApprovalDenialTrendRequest = (payload: any) => ({
  type: PSMS_PA_APPROVAL_DENIAL_TREND_REQUEST,
  payload,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPSMSPAApprovalDenialTrendSuccess = (payload: any) => ({
  type: PSMS_PA_APPROVAL_DENIAL_TREND_SUCCESS,
  payload,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPSMSPAApprovalDenialTrendFailure = (payload: any) => ({
  type: PSMS_PA_APPROVAL_DENIAL_TREND_FAILURE,
  payload,
});

export const getPSMSPAApprovalDenialTrendLoading = (payload: boolean) => ({
  type: PSMS_PA_APPROVAL_DENIAL_TREND_LOADING,
  payload,
});

// TAT Trend Actions
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPSMSPATatTrendRequest = (payload: any) => ({
  type: PSMS_PA_TAT_TREND_REQUEST,
  payload,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPSMSPATatTrendSuccess = (payload: any) => ({
  type: PSMS_PA_TAT_TREND_SUCCESS,
  payload,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPSMSPATatTrendFailure = (payload: any) => ({
  type: PSMS_PA_TAT_TREND_FAILURE,
  payload,
});

export const getPSMSPATatTrendLoading = (payload: boolean) => ({
  type: PSMS_PA_TAT_TREND_LOADING,
  payload,
});
